//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'BaseDialog',
	props: {
		width: String,
		height: String,
		title: String,
		headless: {
			'type': Boolean,
			'default': false,
		},
	},
	computed: {
		cardStyle() {
			const style = {};
			if (this.width) style.width = this.width;
			if (this.height) style.height = this.height;
			return style;
		},
	},
	mounted() {
		this.$parent.show = () => this.show();

		this.$parent.hide = data => this.hide(data);
		this.$parent.ok = data => this.ok(data);
		this.$parent.cancel = () => this.cancel();

		this.$parent.$on('ok', () => this.$refs.dialog.hide());
		this.$refs.dialog.$on('hide', () => this.$parent.$emit('hide'));
	},
	methods: {
		show() {
			this.$refs.dialog.show();
		},
		hide(data) {
			if (data) this.ok(data);
			else this.cancel();
		},
		ok(data) {
			this.$parent.$emit('ok', data);
		},
		cancel() {
			this.$refs.dialog.hide();
		},
	},
};
